/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketspayoutscontinue2Inputs */

const en_ticketspayoutscontinue2 = /** @type {(inputs: Ticketspayoutscontinue2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continue on Stripe`)
};

const de_ticketspayoutscontinue2 = /** @type {(inputs: Ticketspayoutscontinue2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bei Stripe weitermachen`)
};

/**
* | output |
* | --- |
* | "Continue on Stripe" |
*
* @param {Ticketspayoutscontinue2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketspayoutscontinue2 = /** @type {((inputs?: Ticketspayoutscontinue2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketspayoutscontinue2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketspayoutscontinue2(inputs)
	return de_ticketspayoutscontinue2(inputs)
});
export { ticketspayoutscontinue2 as "ticketsPayoutsContinue" }